/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import { setListEntryFocus, setListEntryPosition } from './list.actions';
import {
    REMOVE_LIST_ENTRY,
    SET_LIST_ENTRY,
    SET_LIST_ENTRY_FOCUS,
    SET_LIST_ENTRY_LIMIT,
    SET_LIST_ENTRY_POSITION,
} from './list.types';
import { IListEntry, IListState } from './listprops';

const initialState: IListState = {};

const listReducer = (
    state = initialState,
    { type, payload } = <TivoPayloadAction<{ id: string; entry: IListEntry } & IListEntry>>{},
) => {
    switch (type) {
        case SET_LIST_ENTRY:
            return { ...state, [payload.id]: payload.entry };
        case REMOVE_LIST_ENTRY:
            // eslint-disable-next-line no-case-declarations
            const { [payload.id]: _, ...newState } = state;
            return newState;
        case SET_LIST_ENTRY_LIMIT:
            return { ...state, [payload.id]: { ...state[payload.id], limit: payload.limit } };
        case SET_LIST_ENTRY_POSITION:
            return { ...state, [payload.id]: { ...state[payload.id], position: payload.position } };
        case SET_LIST_ENTRY_FOCUS:
            return {
                ...state,
                [payload.id]: { ...state[payload.id], isFocused: payload.isFocused },
            };
        default:
            return state;
    }
};

export const onKeyDownList = (id: string) => (dispatch: Function, getState: Function) => {
    const { position, limit } = getState().list[id];

    const newPosition = position + 1;
    if (newPosition < limit) {
        dispatch(setListEntryPosition(id, newPosition));
    }
};

export const onKeyLeftList = (id: string) => (dispatch: Function, getState: Function) => {
    const { position } = getState().list[id];

    const newPosition = position - 1;
    if (newPosition >= 0) {
        dispatch(setListEntryPosition(id, newPosition));
    }
};

export const onKeyRightList = (id: string) => (dispatch: Function, getState: Function) => {
    const { position, limit } = getState().list[id];

    const newPosition = position + 1;
    if (newPosition < limit) {
        dispatch(setListEntryPosition(id, newPosition));
    }
};

export const onKeyUpList = (id: string) => (dispatch: Function, getState: Function) => {
    const { position } = getState().list[id];

    const newPosition = position - 1;
    if (newPosition >= 0) {
        dispatch(setListEntryPosition(id, newPosition));
    }
};

export const onMouseOverList = () => (dispatch: Function, getState: Function) => {
    const { value } = getState().inputFactory;

    const menuItems = value.split('_');
    const position = Number(menuItems[0]);
    const id = menuItems[1];

    dispatch(setListEntryPosition(id, position));
    dispatch(setListEntryFocus(id, true));
};

export const onMouseOutList = () => (dispatch: Function, getState: Function) => {
    const { value } = getState().inputFactory;

    const menuItems = value.split('_');
    const id = menuItems[1];

    dispatch(setListEntryFocus(id, false));
};

export default listReducer;
